import React, {Component} from "react"
import PropTypes from "prop-types"
import MaskedInput from 'react-text-mask'
import _ from 'lodash'

export default class NRTPhoneInput extends Component {


    state = {
        value : ''
    }

    componentDidMount() {
        this.input = React.createRef()
    }

    static getDerivedStateFromProps(nextProps) {
        return {
            value:nextProps.value
        }
    }



    focus() {
        const input = _.get(this.input , 'current.inputElement')

        if (input )
            input.focus()

    }


    handleChange = (evt) => {
        this.props.onChange(evt.target.value)
    }


    render() {

        const num = /[0-9]/
        let value = _.get(this.props, 'value' , '' )
        value = value != null ? value.replace(/\D+/g, '') : ''

        const mask = value.charAt(2) !== '9' ?
            ['(',num, num, ')', ' ', num, num, num, num, '-', num, num, num, num] :
            ['(',num, num, ')', ' ' ,   num, num, num, num, num, '-', num, num, num, num]

        return (
            <div className={'nrt-form-input'}>

                <MaskedInput
                    tepe={'tel'}
                    mask={mask}
                    guide={false}
                    ref={this.input}
                    {...this.props}
                    value={this.state.value}
                    onChange={this.handleChange}
                />
            </div>
        )
    }
}

NRTPhoneInput.propTypes = {
    onChange: PropTypes.func,
}

NRTPhoneInput.defaultProps = {
}



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/PhoneInput/index.js